import { Link } from "react-router-dom";
import { BILLING } from "@/constants/testIds";
import { XCircle } from "lucide-react";

export default function BillingCancel() {
  return (
    <div
      data-testid={BILLING.cancelContainer}
      className="p-10 max-w-2xl mx-auto"
    >
      <XCircle className="w-16 h-16 mb-6 text-neutral-400" strokeWidth={1.5} />
      <div className="overline mb-3">Checkout canceled</div>
      <h1 className="font-display text-5xl font-black tracking-tighter mb-4">
        No charge made.
      </h1>
      <p className="text-neutral-500 mb-8">
        Your subscription wasn't activated. You can pick a plan again anytime.
      </p>
      <Link to="/billing" className="lf-btn-primary inline-block">
        Choose a plan →
      </Link>
    </div>
  );
}
